import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Text,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { useTranslation } from 'react-i18next'

const languages = [
  { code: 'en', labelKey: 'languageSwitcher.languages.en', shortName: 'EN' },
  {
    code: 'zh-CN',
    labelKey: 'languageSwitcher.languages.zhCN',
    shortName: 'zh-CN',
  },
  {
    code: 'zh-TW',
    labelKey: 'languageSwitcher.languages.zhTW',
    shortName: 'zh-TW',
  },
] as const

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation()
  const menuBg = useColorModeValue('white', 'gray.700')
  const menuBorder = useColorModeValue('gray.200', 'gray.600')
  const selectedLanguageBg = useColorModeValue('blue.50', 'blue.900')
  const menuItemHoverBg = useColorModeValue('gray.100', 'gray.600')

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0]

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode)
  }

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant="ghost"
        size="sm"
        px={{ base: 2, md: 4 }}
        fontWeight="normal"
      >
        <HStack spacing={2}>
          <Text display={{ base: 'none', md: 'block' }} fontSize="sm">
            {t(currentLanguage.labelKey)}
          </Text>
          <Text display={{ base: 'block', md: 'none' }} fontSize="xs">
            {currentLanguage.shortName}
          </Text>
        </HStack>
      </MenuButton>
      
      <MenuList 
        bg={menuBg} 
        borderColor={menuBorder}
        minW="150px"
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            bg={i18n.language === language.code ? selectedLanguageBg : 'transparent'}
            _hover={{
              bg: menuItemHoverBg
            }}
          >
            <Text fontSize="sm" fontWeight="medium">
              {t(language.labelKey)}
            </Text>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}
